import React, { useState, useImperativeHandle, forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import {
    Form,
    message
} from "antd";
import LocalStorageService from "../../../../utils/localStorageServices";
import { useGenericMutation } from "../../../../queries/use-generic-mutation";
import CommonForm from "../../../global/form";
import SOURCES from "../../../../utils/constants";

const localStorageServices = LocalStorageService.getService();

const EnhancedChangePassword = forwardRef((props, ref) => {
    const currentUser = localStorageServices.getCurrentUser();
    const [form] = Form.useForm();

    const changeUserPassword = useGenericMutation({
        endpoint: `user/changepassword`,
        onSuccess: () => {
            message.success("Password changed successfully");
            form.resetFields();
        },
        onError: (err) => {
            const errorMsg = err?.response?.data?.data?.error || "Error changing password";
            message.error(errorMsg);
        }
    });

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            return await changeUserPassword.mutateAsync({
                email: currentUser?.user?.email,
                currentPassword: values.currentPassword,
                newPassword: values.password,
                confirmPassword: values.confirmPassword,
            });

        } catch (e) {
            console.log("Validation Failed:", e);
            throw e;
        }
    };

    useImperativeHandle(ref, () => ({
        submit: handleSubmit,
        isPending: changeUserPassword.isPending
    }));

    const formData = [
        {
            label: "Current Password",
            name: "currentPassword",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "password",
            placeholder: "Enter current password",
            required: true,
            message: "Current password is required.",
            span: 24
        },
        {
            label: "New Password",
            name: "password",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "password",
            placeholder: "Enter new password",
            required: true,
            message: "Please enter a new password.",
            span: 12
        },
        {
            label: "Confirm Password",
            name: "confirmPassword",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "password",
            placeholder: "Confirm new password",
            required: true,
            message: "Please confirm your password.",
            span: 12
        }
    ];

    return (
        <div className="w-full">
            <CommonForm
                data={formData}
                form={form}
                className="password-form"
            />
        </div>
    );
});

export default EnhancedChangePassword;
